







import { Component, Vue } from 'vue-property-decorator';

import requesterHome from '@/components/home/requester/HomeComponent.vue';
import workerHome from '@/components/home/worker/HomeComponent.vue';
import { User } from 'oidc-client';

@Component({
  components: {
    requesterHome,
    workerHome
  }
})
export default class Home extends Vue {
  get currentUser(): User {
    return this.$store.state.user;
  }
}
